<template>
  <div class="footer">
    <div>
      <a href="http://www.beian.miit.gov.cn/" target="_blank">{{ renderInternetContentProvider }}</a>
    </div>
    <div v-if="origin === 'http://www.bxgxxzx.vip'">万星教育科技（天津）有限公司</div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    origin() {
      return window.location.origin;
    },
    renderInternetContentProvider() {
      if (this.origin === 'http://www.bxgxxzx.vip') {
        return '津ICP备20004821号';
      }
      return '津ICP备19001815号-1';
    },
  },
};
</script>

<style lang="scss">
  @import '@/styles/variables.scss';
  .footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    font-size: 12px;
    line-height: 20px;
    color: #ccc;
    text-align: center;
    a {
      color: #fff!important;
    }
  }
</style>
